var pluralize = function (count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    if (count === 1) {
        return noun;
    }
    switch (suffix) {
        case 's':
        case 'es':
            return "".concat(noun).concat(suffix);
        case 'ies':
            return "".concat(noun.slice(0, noun.length - 1)).concat(suffix);
        default:
            return noun;
    }
};
export { pluralize };
